import {ChooseDropdown, DropdownSelectTrigger} from '@priority-software/priority-style-react';
import React from 'react';
import {emailDialogID} from '../../../../../testIDs';
import cx from 'classnames';
import styles from '../styles.module.scss';
import {useFontDropdown} from '../../hooks/useFontDropdown';
import {shouldAddDots} from '../utils';
import {DropdownItemData} from '@priority-software/priority-style-react/dist/components/DropdownV2/ChooseDropdown/ChooseDropdown';
import {TMode} from '../../../types';
import {LexicalEditor} from 'lexical';
import {createDataTestId} from '../../../../../../../utils/dataTestId';
import {useEmailContext} from '../../../../../context';

interface IFontDropdownProps {
    options: DropdownItemData[];
    mode: TMode;
    value: DropdownItemData;
    editor: LexicalEditor;
    setIsDropdownOpen: (isOpen: boolean) => void;
}

export const FontDropdown = ({
    options,
    mode,
    value,
    editor,
    setIsDropdownOpen
}: IFontDropdownProps) => {
    const {handleChange, isFontSize, selected, isRTL} = useFontDropdown({mode, value, editor});
    const {states} = useEmailContext();

    const testID = `toolbar-${isFontSize ? 'font-size' : 'font-family'}`;

    return (
        <div
            {...createDataTestId(`${testID}-container`, false)}
            className={cx(
                {[isRTL ? styles.marginLeft : styles.marginRight]: !isFontSize},
                isFontSize ? styles.fontSizeDropdown : styles.fontFamilyDropdown
            )}
        >
            <ChooseDropdown
                {...createDataTestId(`${testID}-dropdown`, true)}
                data={options}
                hasSearch={false}
                trigger={
                    <DropdownSelectTrigger
                        {...createDataTestId(`${testID}-dropdown-trigger`, true)}
                        size="small"
                        beforeValue={
                            selected ? shouldAddDots(selected.value as string) : value.label
                        }
                    />
                }
                onOpen={() => setIsDropdownOpen(true)}
                onChange={handleChange}
                usePortal
                disabled={states.focusSubject}
                portalSelector={emailDialogID}
                maxScrollHeight={320}
                contentComponentClasses={cx({[styles.dropdownSize]: isFontSize})}
            />
        </div>
    );
};
